import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user/user.service';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ImageCacheService } from 'src/app/core/services/image/image-cache.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  @ViewChild('password') confpassword: ElementRef;
  userinfo: any;
  session: any;
  agence: any;
  passwordForm: any;
  chgPassword: boolean;
  status: boolean;
  validform: boolean;
  profileImageBase64: string | null = null;

  constructor(private dialogref: MatDialogRef<ProfileComponent>, private fb: FormBuilder, private userservice: UserService, private toastrService: ToastrService,
    private imageCacheService: ImageCacheService) {
    this.confpassword = {} as ElementRef;
    this.userinfo = localStorage.getItem('userinfo');
    this.userinfo = JSON.parse(this.userinfo);
    this.userinfo = this.userinfo[0];
    this.session = localStorage.getItem('session');
    this.agence = localStorage.getItem('agenceinso');
    this.chgPassword = false;
    this.status = false;
    this.validform = false;
  }

  close(): void {
    this.dialogref.close();
  }

  changePassword(): any {
    if (this.chgPassword) {
      this.chgPassword = false;
    } else {
      this.chgPassword = true;
    }
  }

  ngOnInit(): void {
    this.agence = localStorage.getItem('agenceinso');
    this.passwordForm = this.fb.group({
      currentPassword: ['',[Validators.required]],
      newPassword: ['',[Validators.required]],
      confirmPassword: ['',[Validators.required]]
    });
    this.passwordForm.get('confirmPassword').valueChanges.subscribe((result: any) => {
      if(this.passwordForm.get('newPassword').value != result){
        this.toastrService.error('Les  mot de passe ne corresponde pas', 'Mot de passe', {
          timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
        });
        this.validform = false;
      }else{
        this.validform = true;
      }
    });
    this.passwordForm.get('currentPassword').valueChanges.subscribe((data: any) =>{
      this.userservice.checkpassword(this.userinfo.account.accountid, this.passwordForm.get('currentPassword').value).subscribe((response: any)=>{
        // console.log(response);
      });
    });
    this.loadProfileImage();
  }

  loadProfileImage(): void {
    this.imageCacheService
      .getImage('../../../../assets/images/profile.jpg')
      .subscribe({
        next: (base64: string) => {
          this.profileImageBase64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading profile image:', error);
          // Fallback to direct path will be used via template binding
        }
      });
  }

  updatepassword(): any{
    if (this.passwordForm.get('newPassword').value != this.passwordForm.get('confirmPassword').value){
      this.toastrService.error('Les  mot de passe ne corresponde pas', 'Mot de passe', {
        timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
      });
      return;
    }
    this.userservice.updatepassword(this.userinfo.account.accountid, this.passwordForm.get('newPassword').value).subscribe((response: any) => {
      this.toastrService.success('Mot de passe modifier avec success', 'Mot de passe', {
        timeOut: 5000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
      });
      this.close();
    });
  }

  ngAfterViewInit(): any {
    }


}
